import { gql } from "@apollo/client";

export const QUERY_SERVERCATALOG = gql`
  query ServerCatalog ($priceGroup: String){
      serverCatalog (priceGroup: $priceGroup) {
        priceGroup
        disks { price sizes }
        bandwidths { price sizes }
        computes {             
            prices  {
              price
              discount {
                price
                period
              }
            }
            hardware { disk vcpu memory bandwidth }
            diskAvailable { min max }
            bandwidthAvailable { min max }
            included {
              disk
              bandwidth
            }
        }
    }
 }
`

export const QUERY_IMAGES = gql`
  query{
  images{
    id
    type
    flags
    minRequirements{
      disk
      vcpu
      memory
    }
    template{
      name
      description
      creationDate
      status
      actions{
				cancel
      }
    }
    operationalSystem{
      name
      shortName
      version
      arch
      price{
        unitPrice
        chargeType
      }
    }
    application{
      name
      shortName
      version
      link
      price{
        unitPrice
        chargeType
      }
    }
  }
}
`